import React, {useCallback} from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import {BooleanButtons} from '../BooleanButtons';
import {QuestionType} from './ListQuestions';

type Props = QuestionType & {
    onChange: (val: number, ScrLine: number) => void;
    componentClasses?: string;
};

export const Question = ({
    onChange,
    value,
    questionID,
    componentClasses,
    question,
    ScrLine
}: Props) => {
    const onValueChange = useCallback(
        (value: number) => onChange(value, ScrLine),
        [onChange, ScrLine]
    );

    return (
        <Flex componentClasses={componentClasses}>
            <Text textColor="primary-700" skin="paragraph-1">
                {question}
            </Text>
            <BooleanButtons value={value} name={questionID} onChange={onValueChange} />
        </Flex>
    );
};
